import { render, staticRenderFns } from "./STextDescEditor.vue?vue&type=template&id=2ccd22dc&"
import script from "./STextDescEditor.vue?vue&type=script&lang=js&"
export * from "./STextDescEditor.vue?vue&type=script&lang=js&"
import style0 from "./STextDescEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports